import { Server } from 'miragejs';
import routes from './apis/__mocks__/mock-routes';

export function makeServer({ environment = 'development' } = {}) {
  const server = new Server({
    environment,

    routes() {
      for (let i = 0; i < routes.length; i++) {
        const { route, method = 'get', options = {} } = routes[i];

        this[method](
          route,
          async (_schema, req) => {
            const { default: response } = await import(
              `apis/__mocks__/${route}/${method.toUpperCase()}`
            );
            return typeof response === 'function' ? response(req) : response;
          },
          options
        );
      }
    },
  });

  return server;
}
